import { Map } from "immutable"

import {
    getList,
    getItem,
    patchItem,
    postItem,
    deleteItem
} from "./utils/entity-network-requests"

const entityName = "cluster"

export const getClusterList = (token, parameters) => {
    if (typeof parameters === "string" || parameters instanceof String) {
        // Actually a search term that comes from autocomplete
        parameters = new Map({ title: parameters })
    }
    return getList(entityName, parameters, token)
}
export const getClusterItem = (token, id) => getItem(entityName, id, token)
export const patchClusterItem = (token, id, cluster) =>
    patchItem(entityName, id, cluster, token)
export const postClusterItem = (token, cluster) =>
    postItem(`${entityName}/new`, cluster, token)
export const deleteClusterItem = (token, id) =>
    deleteItem(entityName, id, token)
